// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your Firebase config (from Firebase Console)
const firebaseConfig = {
    apiKey: "AIzaSyCg9oBHMzb_JZ6i8xW1tKH-2ZDXDPzt2x8",
    authDomain: "ideate-1eff4.firebaseapp.com",
    projectId: "ideate-1eff4",
    storageBucket: "ideate-1eff4.firebasestorage.app",
    messagingSenderId: "914033747902",
    appId: "1:914033747902:web:3ef2c61eeee23020147bef",
    measurementId: "G-8HGTPN3WDN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get instances of Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;






















// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCg9oBHMzb_JZ6i8xW1tKH-2ZDXDPzt2x8",
//   authDomain: "ideate-1eff4.firebaseapp.com",
//   projectId: "ideate-1eff4",
//   storageBucket: "ideate-1eff4.firebasestorage.app",
//   messagingSenderId: "914033747902",
//   appId: "1:914033747902:web:3ef2c61eeee23020147bef",
//   measurementId: "G-8HGTPN3WDN"
// };

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);